const createTreeFromList = (list) => {
  let map = {},
    node,
    roots = [],
    i;

  for (i = 0; i < list.length; i += 1) {
    map[list[i].id] = i; // initialize the map
    list[i].children = []; // initialize the children
  }

  for (i = 0; i < list.length; i += 1) {
    node = list[i];
    if (!!node.parentId && list[map[node.parentId]]) {
      list[map[node.parentId]]?.children?.push(node);
    } else {
      roots.push(node);
    }
  }
  return roots;
};

const flattenTree = (tree, flattedArray = []) => {
  for (let index = 0; index < tree.length; index++) {
    flattedArray.push({ ...tree[index], children: [] });
    if (tree[index]?.children?.length) {
      flattenTree(tree[index].children, flattedArray);
    }
  }

  return flattedArray;
};

const buildNode = (accountId, supervisor) => ({
  id: accountId,
  parentId: supervisor,
  expanded: true,
  children: [],
});

const assignDepth = (depth) => (node) => {
  node.depth = depth;
  (node.children || []).forEach(assignDepth(depth + 1));
};

export const buildDynamicStructure = (
  users,
  supervisorFieldId,
  buildDepthLevels
) => {
  const allUsers = users.map((user) => ({
    id: user.accountId,
    supervisor: user?.values?.[supervisorFieldId],
    isGrayed: !!user?.isGrayed,
  }));

  const unsortedNodes = [];

  for (let index = 0; index < allUsers.length; index++) {
    const user = allUsers[index];
    unsortedNodes.push({
      ...buildNode(user.id, user.supervisor),
      isGrayed: user.isGrayed,
    });
  }

  const tree = createTreeFromList([...unsortedNodes]);

  const builtStructure = {
    id: "root-level",
    expanded: true,
    level: -1,
    children: tree || [],
  };

  if (buildDepthLevels) {
    builtStructure.children.forEach(assignDepth(1));
  }

  return builtStructure;
};

export const filterTreeBasedOnLevel = (tree, level) => {
  const flattenedTree = flattenTree(tree);
  const filteredByLevel = flattenedTree.filter((node) => node.depth <= level);
  const newTree = createTreeFromList([...filteredByLevel]);

  const builtStructure = {
    id: "root-level",
    expanded: true,
    level: -1,
    children: newTree || [],
  };
  return builtStructure;
};

export const filterManualTreeBasedOnLevel = (tree, level) => {
  const treeWithDepth = { ...tree };
  treeWithDepth?.children?.forEach(assignDepth(1));

  const newStructure = filterTreeBasedOnLevel(treeWithDepth.children, level);
  return newStructure;
};

export const addOrUpdateParentIdsInStructure = (tree) => {
  const newTree = tree?.children
    ? { ...tree }
    : {
        id: "root-level",
        expanded: true,
        children: [],
      };

  const addParentIdsToItems = (structure, parentId) => {
    for (let index = 0; index < structure.length; index++) {
      const parentIdOfCurrentUser = structure[index].id;
      structure[index].parentId = parentId;
      if (structure[index]?.children?.length) {
        addParentIdsToItems(structure[index].children, parentIdOfCurrentUser);
      }
    }
  };

  addParentIdsToItems(newTree.children, undefined);

  return newTree;
};
